import { WhitelistAction } from '../global';

export const CLEAR_TRAVELLERS_PLAN_STATE = 'CLEAR_TRAVELLERS_PLAN_STATE';
export const CLEAR_TRAVELLERS_PLAN_STATE_PAX = 'CLEAR_TRAVELLERS_PLAN_STATE_PAX';
export const TRAVELLER_PLAN = 'TRAVELLER_PLAN';
export const TRAVELLER_AGE = 'TRAVELLER_AGE';
export const TRAVELLER_BENEFIT = 'TRAVELLER_BENEFIT';
export const TRAVELLER_CLEAR_PLAN = 'TRAVELLER_CLEAR_PLAN';
export const TRAVELLER_CLEAR_ALL_PLANS = 'TRAVELLER_CLEAR_ALL_PLANS';
export const TRAVELLER_CLEAR_BENEFIT = 'TRAVELLER_CLEAR_BENEFIT';
export const TRAVELLERS_PLAN_PARAMS = 'TRAVELLERS_PLAN_PARAMS';
export const TRAVELLER_EXCLUSIONS = 'TRAVELLER_EXCLUSIONS';
export const TRAVELLER_ELIGIBILITY = 'TRAVELLER_ELIGIBILITY';
export const TRAVELLER_AMF_REQUIREMENTS = 'TRAVELLER_AMF_REQUIREMENTS';
export const TRAVELLER_PLAN_COVERAGE = 'TRAVELLER_PLAN_COVERAGE';
export const TRAVELLER_SYNC_RATES = 'TRAVELLER_SYNC_RATES';
export type TravellersPlanReducerPayload =
  | TravellerAge
  | TravellerPlanPayload
  | TravellerParams
  | TravellerPaxIds
  | WhitelistAction
  | boolean
  | string;

export enum PRODUCT_TYPE {
  PLAN = 'plan',
  OPTIONAL_BENEFIT = 'optionalBenefit',
  ADD_ON = 'addon'
}

export enum COVERAGE_AMOUNT_KEY {
  DEFAULT = 'default',
  SUPERVISA_NO = 'superVisaNo'
}

export interface PlanParams {
  deductible?: number;
  daysPerTrip?: string;
  sumInsured?: number;
  tripCost?: number;
  // TODO: Will remove this field since the TripCancellation plan needs this value in the current quote-api?
  coverageAmount?: number;
}

export interface TravellerAge {
  age?: number;
  dateOfBirth?: string;
  format: string;
  paxId: number;
  ageCalcDate?: string;
}

export interface TravellerPlanPayload {
  paxId: number;
  code: string;
  age?: number;
  premium?: number;
  tax?: number;
  total?: number;
  type?: PRODUCT_TYPE;
}

export interface TravellerPaxIds {
  paxIds: number[];
}

export interface TravellerProduct {
  params?: PlanParams;
  paxId?: number;
  age?: number;
  dateOfBirth?: string;
  code?: string;
  planClass?: string;
  premium?: number;
  familyRate?: number;
  familyPremium?: number;
  tax?: number;
  total?: number;
  type?: PRODUCT_TYPE;
  dateFormat?: string;
  tripBookingDate?: string;
}

export interface TravellerParams {
  paxId: number;
  params?: PlanParams;
  plan: string;
  tripPreference?: PlanParams;
  code?: string;
}

export interface TravellerProductDetails {
  products?: TravellerProduct[];
  tripParams?: TravellerParams[];
  exclusions?: boolean;
  eligibility?: boolean;
  amfRequirement?: boolean;
  coverage?: string;
}

export interface ClearPlan {
  paxId: number;
  code?: string;
  benefits?: string[];
  type?: PRODUCT_TYPE;
}

export interface TravellerProductDetailsAction {
  type: string;
  payload?: TravellersPlanReducerPayload;
}
